import { render, staticRenderFns } from "./IntegraChange.vue?vue&type=template&id=b5631ff8&scoped=true"
import script from "./IntegraChange.vue?vue&type=script&lang=js"
export * from "./IntegraChange.vue?vue&type=script&lang=js"
import style0 from "./IntegraChange.vue?vue&type=style&index=0&id=b5631ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5631ff8",
  null
  
)

export default component.exports